namespace $.$$ {
	$mol_style_define( $shm_hitalama_guide_editor, {
		width: '42rem', minWidth: 0, flex: { basis: '42rem', grow: 0, shrink: 0 },
		Text_input: { minHeight: '20rem' },
	})
}
